import angular from 'angular';

!function (window, document, undefined) {
  let getModule = function (angular) {
    return angular.module('seo', [])
      .run([
        '$rootScope',
        function ($rootScope) {
          $rootScope.htmlReady = () => {
            $rootScope.$evalAsync(() => { // fire after $digest
              setTimeout(() => { // fire after DOM rendering
                if (typeof window.callPhantom === 'function') {
                  window.callPhantom();
                }
              }, 0);
            });
          };
        }
      ]);
  };
  if (typeof define === 'function' && define.amd)
    define(['angular'], getModule);
  else
    getModule(angular);
}(window, document);